import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/workspace/$workspaceSlug/")({
  component: WorkspaceIndex,
});

function WorkspaceIndex() {
  const { workspaceSlug } = Route.useParams();

  return <Navigate to="/workspace/$workspaceSlug/new-task" params={{ workspaceSlug }} />;
}
